export default __webpack_public_path__ + "static/media/email.4de6df96.svg";